import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { DataProvider } from "../../providers/data/data";
import { HomePage } from '../home/home';

@IonicPage()
@Component({
  selector: 'page-admin',
  templateUrl: 'admin.html',
})
export class AdminPage {
  private locName: string;
  private locDesc: string;
  private firstName: string;
  private lastName: string;
  private email: string;
  private password: string;
  private name: string;
  private description: string;

  private locShown = false;
  private usrShown = false;
  private catShown = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, public dataProvider: DataProvider) {

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AdminPage');
  }

  public addLocation() {
    if (this.locName == undefined) {
      return false;
    }

    if (this.locDesc == undefined) {
      return false;
    }

    let location = {
      "AccountId": sessionStorage.getItem("__aid__"),
      "Name": this.locName,
      "Description": this.locDesc
    };

    this.dataProvider.locationPost(location).
      then(this.getResponse).
      then(res => {
        this.loadHomePage();
      }).
      catch();
  };

  public addUser() {
    if (this.firstName == undefined) {
      return false;
    }

    if (this.lastName == undefined) {
      return false;
    }

    if (this.email == undefined) {
      return false;
    }

    if (this.password == undefined) {
      return false;
    }

    let user = {
      "AccountId": sessionStorage.getItem("__aid__"),
      "FirstName": this.firstName,
      "LastName": this.lastName,
      "Email": this.email,
      "Password": this.password
    };

    this.dataProvider.userPost(user).
      then(this.getResponse).
      then(res => {
        this.loadHomePage();
      }).
      catch();
  };

  public addCategory() {
    if (this.name == undefined) {
      return false;
    }

    if (this.description == undefined) {
      return false;
    }

    let category = {
      "AccountId": sessionStorage.getItem("__aid__"),
      "Name": this.name,
      "Description": this.description
    };

    this.dataProvider.categoryPost(category).
      then(this.getResponse).
      then(res => {
        this.loadHomePage();
      }).
      catch();
  }

  private getResponse(res) {
    return res.json();
  };

  private loadHomePage() {
    this.navCtrl.push(HomePage);
  };

  public toggleGroup(group) {
    if (group == 0) {
      this.locShown = true;
      this.usrShown = false;
      this.catShown = false;
    }

    if (group == 1) {
      this.locShown = false;
      this.usrShown = true;
      this.catShown = false;
    }

    if (group == 2) {
      this.locShown = false;
      this.usrShown = false;
      this.catShown = true;
    }
  };
}


// WEBPACK FOOTER //
// ./src/pages/admin/admin.ts